import Home from "../_pages/Home";
import Brand from "../_pages/Brand";
import Profile from "../_pages/Profile"
import { Invite, SuperInvite } from "../_pages/Invite"
import Simulation from "../_pages/Simulation"
import SimulationDetail from "../_pages/SimulationDetail"
import Agency from "../_pages/Agency"
import Admins from "../_components/Agency/Admins"
import Project from "../_pages/Project"
import Cost from "../_pages/Cost"
import Pricing from "../_pages/Pricing"


const ProtectedRotues = [
  {
    path: "/",
    element: <Home />,
    allowedRoles: ['admin','super_admin','user'],
  },

  {
    path: "/users",
    element: <SuperInvite />,
    allowedRoles: ['super_admin'],
  },
  
  {
    path: "/agencies",
    element: <Agency/>,
    allowedRoles: ['super_admin'],
  },
  {
    path: "/admins",
    element: <Admins/>,
    allowedRoles: ['super_admin'],
  },
  {
    path: "/brands",
    element: <Brand/>,
    allowedRoles: ['admin','super_admin','user'],
  },
  {
    path: "/projects",
    element: <Project/>,
    allowedRoles: ['admin','super_admin','user'],
  },
  {
    path:'/profile',
    element:<Profile />,
    allowedRoles: ['user','admin','super_admin'],
  },
  {
    path:'/invite',
    element:<Invite />,
    allowedRoles: ['admin'],
  },
  { 
    path:'/simulations',
    element:<Simulation />,
    allowedRoles: ['admin','super_admin','user'],
  },
  {
    path: '/simulations/details/:id',
    element: <SimulationDetail />,
    allowedRoles: ['user','admin','super_admin'],
  },
  {
    path: '/simulations/details/:id/:tab',
    element: <SimulationDetail />,
    allowedRoles: ['user','admin','super_admin'],
  },
  {
    path: '/cost',
    element: <Cost />,
    allowedRoles: ['admin', 'super_admin'],
  },
  {
    path: '/pricing/*',
    element: <Pricing />,
    allowedRoles: ['super_admin'],
  },
 
  
];

export default ProtectedRotues;
